import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import GithubSection from "./components/GithubSection";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Effects from "./components/Effects";
import "./style.css";

function App() {
  return (
    <>
      <Effects />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <GithubSection />
        <Resume />
        <Contact />
      </main>
      <footer className="footer">
        <p>© {new Date().getFullYear()} Ahmed Saleem · Built with React</p>
      </footer>
    </>
  );
}

export default App;
